import { twMerge } from 'tailwind-merge';

import { CampaignTypeV2 } from '~/api/v2/schemas/campaign-type';
import { RewardTypeV2 } from '~/api/v2/schemas/reward-type';
import { determineCampaignTypeById } from '~/utils';

export type ShopOfferStyles =
  | string
  | {
      shop: string | { rate: string; amount: string };
      offer: string;
    };

export type CampaignLogoStyles = {
  box: ShopOfferStyles;
  img: ShopOfferStyles;
};

export type CampaignLogoData =
  // CampaignInfoV2 /api/v2/mall/campaign/search
  // CampaignTransferResponseV2 /api/v2/mall/campaign/transfer
  // OfferDetailResponseV2 /api/v2/mall/offer/campaign_id
  // ShopDetailResponseV2 /api/v2/mall/shop/campaign_id
  | {
      campaign_id: number;
      campaign_name: string;
      logo_path: string;
      reward_type?: number;
    }
  // RecommendShopDetailV1 /api/v1/mall/recommend_shop
  | {
      campaign_id: number;
      campaign_name: string;
      image_url: string;
      reward_type?: number;
    };

type CampaignLogoProps<T extends CampaignLogoData> = {
  data: T;
  styles: CampaignLogoStyles;
  className?: string;
  lazy?: boolean;
};

export const CampaignLogo = <T extends CampaignLogoData>(props: CampaignLogoProps<T>) => {
  const { data, styles, className = '', lazy = true } = props;

  const campaignId = data.campaign_id;
  const campaignType = determineCampaignTypeById(Number(campaignId));
  const rewardType = data.reward_type;
  const getClassName = (sos: ShopOfferStyles) => {
    if (typeof sos === 'string') return sos;
    if (campaignType === CampaignTypeV2.SHOP) {
      if (typeof sos.shop === 'string') return sos.shop;
      if (rewardType === RewardTypeV2.RATE) return sos.shop.rate;
      if (rewardType === RewardTypeV2.AMOUNT) return sos.shop.amount;
    }
    return sos.offer;
  };

  const boxClassName = getClassName(styles.box);
  const imgClassName = getClassName(styles.img);

  let src = 'image_url' in data ? data.image_url : data.logo_path;
  let alt = data.campaign_name;
  if (src === '') {
    src = '/images/common/noimage.jpg';
    alt = 'no-image';
  }

  return (
    <div className={twMerge(boxClassName, className)}>
      <img
        src={src}
        alt={alt}
        className={imgClassName}
        loading={lazy ? 'lazy' : 'eager'}
        onError={(e) => {
          e.currentTarget.src = '/images/common/noimage.jpg';
        }}
      />
    </div>
  );
};
